import { useTheme } from "../../contexts/ThemeContext";
import { ToggleButton } from "./ThemeToggle.styles";

export const ThemeToggle = () => {
  const { themeName, toggleTheme } = useTheme();

  return (
    <ToggleButton
      type="button"
      $themeName={themeName}
      aria-label={
        themeName === "dark"
          ? "Переключить на светлую тему"
          : "Переключить на темную тему"
      }
      aria-pressed={themeName === "dark"}
      onClick={toggleTheme}
    >
      <i className="pi pi-sun" aria-hidden="true" />
      <i className="pi pi-moon" aria-hidden="true" />
    </ToggleButton>
  );
};
